<template>
  <h1><span class="text-primary">מדיניות פרטיות</span> אתר {{ $domain }}</h1>
  <AppThirdLayout>
    <h2>איסוף מידע</h2>
    <p>
      אנחנו אוספים מכם מידע כאשר אתם ממלאים טפסים באתר. המידע שנאסף כולל את שמכם,
      כתובת האימייל, מספר הטלפון, ופרטים נוספים אשר אתם בוחרים לתת בעת מילוי
      הטופס. בנוסף, אנחנו מקבלים ושומרים באופן אוטומטי מידע מהמחשב ומהדפדפן שלך,
      כולל כתובת ה-IP שלכם, מאפייני התוכנה והחומרה, ופרטי העמוד שבו ביקשת לצפות.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>שימוש במידע</h2>
    <p>
      <strong>כל מידע שאנחנו אוספים ממך עשוי לשמש כדי</strong>:<br />• להתאים
      באופן אישי את החוויה שלך ולהגיב לצרכים האישיים שלך.<br />• להעניק לכם הנפקה
      מהירה של ויזה אלקטרונית למדינה שתבחרו.<br />• לספק תוכן שיווקי מותאם
      אישית.<br />• לשפר את האתר שלנו.<br />• לשפר את שירות הלקוחות ואת צרכי
      התמיכה שלך.<br />• ליצור אתך קשר באמצעות אימייל או טלפון.<br />• לנהל תחרות,
      מבצע, או סקר.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>פרטיות מסחר אלקטרוני</h2>
    <p>
      אנחנו הבעלים הבלעדיים של המידע שנאסף באתר. המידע על פיו ניתן לזהותך לא
      יימכר, יוחלף, יועבר, או יינתן לאף חברה אחרת בשל כל סיבה שהיא ללא הסכמתך,
      מלבד מידע הכרחי להשלמת בקשה ו/או עסקה, כגון הנפקת ויזה אלקטרונית.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>העברת מידע לצד שלישי</h2>
    <p>
      אנחנו לא מוכרים, סוחרים, או מעבירים בכל דרך שהיא לגופים חיצוניים את המידע
      המאפשר זיהוי אישי שלך. תנאי זה לא כולל חברות צד שלישי מוסמכות שמסייעות לנו
      בתפעול אתר האינטרנט שלנו או בביצוע העסקים שלנו. אנחנו מאמינים ששיתוף מידע
      הוא הכרחי על מנת לחקור, למנוע או לפעול בקשר לפעילויות משפטיות, חשד להונאה,
      מצבים הכוללים איומים אפשריים לביטחונו האישי של כל אדם, הפרות תנאי השימוש
      שלנו, או כפי שנדרש על פי חוק. מידע שאינו אישי, עם זאת, עשוי להינתן לגופים
      חיצוניים למטרות שיווק, פרסום ושימושים אחרים.<br />כחלק מן המאמץ לספק שירות
      מהיר וזול ללקוחות האתר עבור הנפקת אשרות כניסה, מידע ופרטים אישיים, לרבות
      פרטי דרכון, עלולים להישלח לצד שלישי אשר מתעסק בהנפקת ויזות, לדוגמה לרשויות
      ממשלתיות רשמיות ומשרדי הגירה. כל העברת מידע מבוצעת בצורה מאובטחת ואחרי בדיקה
      של אמינות הגורם צד שלישי.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>אבטחת מידע</h2>
    <p>
      אנחנו מיישמים מגוון אמצעי אבטחה מעודכנים כדי לשמור על בטיחות המידע האישי
      שלך. אנחנו משתמשים בהצפנה משוכללת כדי להגן על מידע רגיש שמועבר ברשת. אתר
      "{{ SITE_NAME }}" גם מגן על המידע שלך במצב לא מקוון - רק עובדים שצריכים לבצע עבודה
      מסוימת (למשל שירות לקוחות או הנפקת אשרות) מקבלים גישה למידע המאפשר זיהוי
      אישי. המחשבים/שרתים המשמשים לאחסון מידע המאפשר זיהוי אישי נשמרים בסביבה
      מאובטחת ע"פ תקני SSL ו-PCI המעודכנים לשנת {{  getCurrentYear() }}.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>האם אנו משתמשים בקבצי קוקיז?</h2>
    <p>
      כן. קבצי הקוקי שלנו משפרים את הגישה לאתר שלנו ומזהים מבקרים חוזרים. יתר על
      כן, קבצי הקוקי שלנו משפרים את חוויית המשתמש על ידי מעקב והתמקדות בתחומי
      העניין שלה/שלו. השימוש בקבצי קוקי, עם זאת, לא מקושר באף צורה למידע כלשהו
      באתר שלנו המאפשר זיהוי אישי.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>הסרה ממאגר הנתונים</h2>
    <p>
      אנחנו משתמשים בכתובת האימייל שסיפקת כדי לשלוח לך מידע ועדכונים הנוגעים
      להזמנה שלך, חדשות חברה מזדמנות, מידע על מוצרים קשורים וכד'. אם בשלב כלשהו
      תעדיף להסיר את עצמך מרשימת התפוצה, על מנת שלא לקבל אימיילים בעתיד, אנחנו
      מצרפים הוראות מפורטות להסרה מרשימת התפוצה בתחתית כל אימייל. בנוסף תוכלו
      לפנות אלינו בכל עת עם בקשה להסרה ואנו נבצע אותה תוך שלושה ימי עסקים.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>מחיקת תוכן אישי מהשרת</h2>
    <p>
      תמונות ו/או מידע רגיש אשר משתמשי האתר מעלים לשרת כחלק מתהליך מילוי טופס או
      קבלת שירות, ימחקו זמן קצר לאחר סיום מתן השירות (למשל שליחת אשרה בדוא"ל).
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>הסכמה</h2>
    <p>באמצעות שימוש באתר שלנו, אתם מסכימים למדיניות הפרטיות שלנו.</p>
  </AppThirdLayout>
</template>

<script setup lang="ts">
import { getCurrentYear } from '~/helpers/date';
import { SITE_NAME } from '~/assets/constants';
</script>